module.exports = __webpack_public_path__ + "static/media/free.3372960b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/gift/free.svg
// module id = 918
// module chunks = 0